module.exports = __webpack_public_path__ + "img/diamondsAsSaving.cd1a1c4.jpg";